import { t } from '@lingui/core/macro';
import { ApiErrorPage, ApiErrorPageProps } from 'noddi-ui-web';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { getCommonTranslations } from '../../utils/commonTranslations';
import { getErrorCodesWithTrans } from '../../utils/getErrorCodesWithTranslations';

export const ApiErrorPageWithTrans = ({ ...rest }: Omit<ApiErrorPageProps, 'translations'>) => {
  const { brandEmail } = useCurrentBrand();
  return (
    <ApiErrorPage
      {...rest}
      translations={{
        ...getCommonTranslations().errorPage,
        description: t`Please try again. If the problem persists, don't hesitate to reach out to us at ${brandEmail}`
      }}
      errorCodes={getErrorCodesWithTrans(brandEmail)}
    />
  );
};
